
import React, { Fragment } from 'react';
import { Col } from 'react-bootstrap';

import {
	FiEye,
	FiSettings,
	FiClock,
	FiSpeaker,
	FiPlay,
	FiCloudOff
  } from 'react-icons/fi';

const IndicationItem = ({indication}) => {
	return (
		<Col md={6}
			xxl={4}>
			<div className="hover-bg-100 py-x1 text-center rounded-3 position-relative">
				<div className={
					`icon-item icon-item-xl shadow-none mx-auto mt-x1 bg-soft-${
						indication.color
					}`
				}>
					{
					indication.icon === 'timer' ? (
						<FiClock className="text-success fs-2"/>
					) : (
						<Fragment/>)
				}
					{
					indication.icon === 'distractions' ? (
						<FiEye className="text-info fs-2"/>
					) : (
						<Fragment/>)
				}
					{
					indication.icon === 'engine' ? (
						<FiSettings className="text-primary fs-2"/>
					) : (
						<Fragment/>)
				}
					{
					indication.icon === 'speaker' ? (
						<FiSpeaker className="text-primary fs-2"/>
					) : (
						<Fragment/>)
				}
					{
					indication.icon === 'play' ? (
						<FiPlay className="text-primary fs-2"/>
					) : (
						<Fragment/>)
				}
					{
					indication.icon === 'lostConnection' ? (
						<FiCloudOff className="text-primary fs-2"/>
					) : (
						<Fragment/>)
				} </div>
				<h5 className="mt-3 mb-2">
					<a href="#!" className="text-900 hover-primary stretched-link">
						{
						indication.title
					} </a>
				</h5>
				<h6 className="w-75 mx-auto text-600 mb-x1">
					{
					indication.description
				}</h6>
			</div>
		</Col>
	);
};

export default IndicationItem;